import React, { useEffect, useState } from 'react'
import { useAddBookMutation, useEditBookMutation } from '../features/api/apiSlice'
import { useNavigate } from 'react-router-dom'

export default function Form({ editMode, book }) {
    const navigate = useNavigate()
    const [addBook, { isSuccess: isSuccessBookAdd }] = useAddBookMutation()
    const [editBook, { isSuccess: isSuccessUpdateBook }] = useEditBookMutation()

    const [id, setId] = useState(null)
    const [name, setName] = useState("")
    const [author, setAuthor] = useState("")
    const [thumbnail, setThumbnail] = useState("")
    const [price, setPrice] = useState("")
    const [rating, setRating] = useState(0)
    const [featured, setFeatured] = useState(false)

    useEffect(() => {
        if (isSuccessBookAdd) {
            console.log("book add")
            navigate("/")
        }
        if (isSuccessUpdateBook) {
            console.log("book update")
            navigate("/")
        }
    }, [isSuccessBookAdd, isSuccessUpdateBook, navigate])


    useEffect(() => {
        if (editMode) {
            const { id, name, author, thumbnail, price, rating, featured } = book || {};

            setId(id)
            setName(name)
            setAuthor(author)
            setThumbnail(thumbnail)
            setPrice(price)
            setRating(rating)
            setFeatured(featured)
        }
    }, [editMode, book])


    function handleAddBook(e) {
        e.preventDefault();

        if (name && author && thumbnail && price && rating) {
            addBook({
                name, author, thumbnail, price, rating, featured
            })
        }
    }

    function handleUpdateBook(e) {
        e.preventDefault()
        console.log({
            id, name, author, thumbnail, price, rating, featured
        })
        if (id && name && author && thumbnail && price && rating) {
            editBook({
                id, name, author, thumbnail, price, rating, featured
            })
        }
    }

    return (
        <>
            <h4 class="mb-8 text-xl font-bold text-center">{editMode ? "Edit Book" : "Add New Book"}</h4>
            <form onSubmit={editMode ? handleUpdateBook : handleAddBook} class="book-form">
                <div class="space-y-2">
                    <label for="lws-bookName">Book Name</label>
                    <input required class="text-input" type="text" onChange={e => setName(e.target.value)} value={name} id="lws-bookName" name="name" />
                </div>

                <div class="space-y-2">
                    <label for="lws-author">Author</label>
                    <input required class="text-input" type="text" onChange={e => setAuthor(e.target.value)} value={author} id="lws-author" name="author" />
                </div>

                <div class="space-y-2">
                    <label for="lws-thumbnail">Image Url</label>
                    <input required class="text-input" type="text" onChange={e => setThumbnail(e.target.value)} value={thumbnail} id="lws-thumbnail" name="thumbnail" />
                </div>

                <div class="grid grid-cols-2 gap-8 pb-4">
                    <div class="space-y-2">
                        <label for="lws-price">Price</label>
                        <input required class="text-input" type="number" onChange={e => setPrice(e.target.value)} value={price} id="lws-price" name="price" />
                    </div>

                    <div class="space-y-2">
                        <label for="lws-rating">Rating</label>
                        <input required class="text-input" type="number" onChange={e => setRating(e.target.value)} value={rating} id="lws-rating" name="rating" min="1"
                            max="5" />
                    </div>
                </div>

                <div class="flex items-center">
                    <input id="lws-featured" onChange={e => setFeatured(e.target.checked)} checked={featured} type="checkbox" name="featured" class="w-4 h-4" />
                    <label for="lws-featured" class="ml-2 text-sm"> This is a featured book </label>
                </div>

                <button type="submit" class="submit" id="lws-submit">
                    {editMode ? "Update Book" : "Add Book"}
                </button>
            </form>
        </>
    )
}
